var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"width":"100%","height":"300px","margin":"auto"}},[_c('video',{staticStyle:{"background":"#000"},attrs:{"width":"100%","height":"240","controls":""}},[_c('source',{attrs:{"src":_vm.videoUrl,"type":"video/mp4"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }